import { Link } from "react-router-dom"
import TeamMemberInterface from "../../interfaces/TeamMember.interface"
import { useAppSelector } from "../../store/store"
import ToggleAdminButton from "./ToggleAdminButton"

const TeamMember: React.FC<{ teamMember: TeamMemberInterface }> = ({ teamMember }) => {
    const team = useAppSelector(state => state.team)
    const player = useAppSelector(state => state.player)
    const isMember = player.teams?.find((member) => member.team_id === team.id)

    return (
        <div className="flex flex-col border p-5">
            <Link to={`/p/${teamMember.player?.name}`} className="text-zinc-700 text-lg font-bold">{teamMember.player?.name}</Link>
            {isMember?.admin &&
                <div className="flex items-center gap-2">
                    <ToggleAdminButton teamMember={teamMember} />
                </div>
            }
        </div>
    )
}

export default TeamMember